import React from 'react';
import { Field, Form, reduxForm } from 'redux-form/immutable';
import renderSelect from '../../../../components/Select/reduxForm';
import renderDateRangeField from '../../../../components/DateField/reduxFormDateRangeField';
import { range } from 'lodash';
import Button from '../../../../components/Button';
import colors from '../../../../components/Button/colors';
import { NumberField } from '../../../../components/Field/NumberField';
import {
  isRequiredFn,
  numberFieldRestrict12_2Fn,
  reduxRequired,
} from '../../../Taps/components/NDFL3/services/CommonValidations';
import * as parsers from '../../../../utils/reduxForm/parsers';
import styles from './PaymentInformation.module.scss';
import PropTypes from 'prop-types';
import { addDays, format } from 'date-fns';

function AutoTopupModal({ onReject, handleSubmit, bankCards }) {
  const bankCardOptions = bankCards.map((bankCard) => {
    return {
      value: bankCard.debitCardId,
      label: bankCard.maskedPan,
    };
  });

  const dateOptions = range(1, 29).map((el) => {
    return { value: el, label: el };
  });
  return (
    <div className={`boo ${styles.AutoTopupContent}`}>
      <Form className={'p-3'} onSubmit={handleSubmit}>
        <div className={'H2 mb-4'}>Автопополнение</div>
        <div className={'bg-blue-l-40 p-3 border-blue'}>
          <div className={'mb-3'}>Основные настройки</div>
          <Field
            isFull
            options={bankCardOptions}
            label={'Карта для пополнения кошелька'}
            name={'card'}
            component={renderSelect}
            tooltip={null}
            tooltipContent={
              'Выберете карту для автоматического пополнения кошелька налогоплательщика. Если с указанной карты не удается списать денежные средства три раза подряд, то автопополнение будет отключено'
            }
            isRequired={true}
            validate={isRequiredFn}
          />
          <div className="d-flex flex-column flex-sm-row">
            <Field
              isFull
              wrapperClass={'w-100'}
              label={'День пополнения'}
              name={'topUpDate'}
              options={dateOptions}
              parse={parsers.selectValueParser}
              component={renderSelect}
              tooltip={null}
              tooltipContent={'День пополнения кошелька.'}
              isRequired={true}
              validate={isRequiredFn}
            />
            <Field
              component={NumberField}
              isRequired={true}
              validate={reduxRequired}
              isAllowed={numberFieldRestrict12_2Fn}
              decimalScale={2}
              className={'w-100 ml-sm-3'}
              label={'Сумма пополнения'}
              name={'amount'}
              tooltipContent={'Сумма пополнения кошелька'}
            />
          </div>
          <div className={'S5 mb-3'}>Дополнительные настройки</div>
          <div className={'d-flex'}>
            <Field
              hasHelpWrap={false}
              component={renderDateRangeField}
              minDate={format(addDays(new Date(), 1), 'yyyy-MM-dd')}
              parse={parsers.rangeMomentParser}
              label={'Период действия'}
              name={'activityRange'}
              tooltip={null}
              tooltipContent={
                'Срок действия автоматического пополнения кошелька. Обращаем внимание, что поле «по» является необязательным для заполнения и конечной датой автопополнения в таком случае является дата окончания действия карты.'
              }
            />
          </div>
        </div>
        <div className={'d-flex justify-content-end mt-3'}>
          <Button type={'button'} onClick={onReject} color={colors.WHITE_BLUE} hasWrapper={false}>
            Отменить
          </Button>
          <Button type={'submit'} extraClassName={'ml-3'}>
            Сохранить
          </Button>
        </div>
      </Form>
    </div>
  );
}

export default reduxForm({ form: 'AutoTopUpForm' })(AutoTopupModal);

AutoTopupModal.propTypes = {
  bankCards: PropTypes.array,
  handleSubmit: PropTypes.func,
  onReject: PropTypes.func,
};
